<template>
  <div>
    <site-contractors-table :site-id="siteId" />
  </div>

</template>


<script>

import SiteContractorsTable from '@/components/sites/finance/contractors/SiteContractorsTable'

export default {

  components: {
    SiteContractorsTable
  },


  props: {

    siteId: {
      type: Number,
      required: true
    }

  },


}
</script>
